
import { twMerge } from 'tailwind-merge';
/**
 * Skeleton loader component
 * Used to show loading state while data is being fetched
 */
interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
}

export function Skeleton({ className, ...props }: SkeletonProps) {
  return <div className={twMerge('animate-pulse rounded-md bg-gray-200', className)} {...props} />;
}